<template>
  <div class="app-cancellation-form">
    <slot name="txtBefore"></slot>
    <b-form>
      <b-form-group class="form-group first-name-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="firstNameLabel">Vorname</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col">
            <b-form-input
              name="firstName"
              type="text"
              placeholder="Max"
              v-model="cancellation.customer.firstName"
              @change="$v.cancellation.customer.firstName.$touch"
              :state="isValid('firstName','customer', 'cancellation')"
              aria-describedby="firstName-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="firstName-live-feedback">
              <slot v-if="!isValid('firstName')" name="firstNameLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group last-name-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="lastNameLabel">Nachname</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col last-name-col">
            <b-form-input
              name="lastName"
              type="text"
              placeholder="Mustermann"
              v-model="cancellation.customer.lastName"
              @change="$v.cancellation.customer.lastName.$touch"
              :state="isValid('lastName','customer', 'cancellation')"
              aria-describedby="lastName-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="lastName-live-feedback">
              <slot v-if="!isValid('lastName','customer', 'cancellation')" name="lastNameLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group street-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="streetLabel">Straße</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col street-col">
            <b-form-input
              name="street"
              type="text"
              placeholder="Musterstr."
              v-model="cancellation.address.street"
              @change="$v.cancellation.address.street.$touch"
              :state="isValid('street','address', 'cancellation')"
              aria-describedby="street-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="street-live-feedback">
              <slot v-if="!isValid('street','address', 'cancellation')" name="streetLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group house-number-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="houseNumberLabel">Hausnummer</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col house-number-col">
            <b-form-input
              name="houseNumber"
              type="text"
              placeholder="1a"
              v-model="cancellation.address.houseNumber"
              @change="$v.cancellation.address.houseNumber.$touch"
              :state="isValid('houseNumber','address', 'cancellation')"
              aria-describedby="houseNumber-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="houseNumber-live-feedback">
              <slot v-if="!isValid('houseNumber','address', 'cancellation')" name="houseNumberLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group zip-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="zipLabel">Postleitzahl</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col zip-col">
            <b-form-input
              name="zip"
              type="text"
              placeholder="12345"
              v-model="cancellation.address.zip"
              @change="$v.cancellation.address.zip.$touch"
              :state="isValid('zip','address', 'cancellation')"
              aria-describedby="zip-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="zip-live-feedback">
              <slot v-if="!isValid('zip','address', 'cancellation')" name="zipLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group city-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="cityLabel">Stadt</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col city-col">
            <b-form-input
              name="city"
              type="text"
              placeholder="Musterstadt"
              v-model="cancellation.address.city"
              @change="$v.cancellation.address.city.$touch"
              :state="isValid('city','address', 'cancellation')"
              aria-describedby="city-live-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="city-live-feedback">
              <slot v-if="!isValid('city','address', 'cancellation')" name="cityLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind Buchstaben, Zahlen und diese Sonderzeichen . , - /
                erlaubt.“
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group email-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="zipLabel">E-Mail-Adresse</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="indicator">
            <b-form-input
              name="email"
              type="email"
              @change="$v.cancellation.email.$touch"
              :state="isValid('email','cancellation')"
              v-model="cancellation.email"
              aria-describedby="email-live-feedback"
              placeholder="max.mustermann1@muster.de"
            ></b-form-input>
            <slot name="emailIndication"></slot>
            <b-form-invalid-feedback id="email-live-feedback">
              <slot v-if="!isValid('email', 'cancellation')" name="emailLiveFeedback">
                Bitte prüf Deine Eingabe. Deine Eingabe entspricht keinem E-Mail-Format
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group customer-number-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="firstNameLabel">Kundennummer</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col indicator">
            <b-form-input
              name="curstomerNumber"
              type="text"
              placeholder="123456789"
              v-model="cancellation.customer.customerID"
              @change="$v.cancellation.customer.customerID.$touch"
              :state="isValid('customerID','customer', 'cancellation')"
              aria-describedby="customerID-live-feedback"
            >
            </b-form-input>
            <slot name="customerIDIndication"></slot>
            <b-form-invalid-feedback id="customerID-live-feedback">
              <slot v-if="!isValid('customerID','customer', 'cancellation')" name="customerIDLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind nur Zahlen und diese Sonderzeichen , - / erlaubt
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group contract-number-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="firstNameLabel">Vertragsnummer</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col indicator">
            <b-form-input
              name="contractNumber"
              type="text"
              placeholder="123456789 oder 0172/1234567"
              v-model="cancellation.customer.contractID"
              @change="$v.cancellation.customer.contractID.$touch"
              :state="isValid('contractID','customer', 'cancellation')"
              aria-describedby="contractID-live-feedback"
            >
            </b-form-input>
            <slot name="contractNumberIndication"></slot>
            <b-form-invalid-feedback id="contractID-live-feedback">
              <slot v-if="!isValid('contractID','customer', 'cancellation')" name="contractIDLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld sind nur Zahlen und diese Sonderzeichen , - / erlaubt
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group termination-date-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="firstNameLabel">Gewünschter Kündigungstermin</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col indicator">
            <b-form-input
              name="preferredCancellationDate"
              type="text"
              placeholder="frühestmöglich"
              v-model="cancellation.preferredCancellationDate"
              @change="$v.cancellation.preferredCancellationDate.$touch"
              :state="isValid('preferredCancellationDate', 'cancellation')"
              aria-describedby="preferredCancellationDate-live-feedback"
            >
            </b-form-input>
            <slot name="terminationDateIndication"></slot>
            <b-form-invalid-feedback id="preferredCancellationDate-live-feedback">
              <slot v-if="!isValid('preferredCancellationDate','cancellation')"
                    name="preferredCancellationDateLiveFeedback">
                Bitte prüf Deine Eingabe. In diesem Feld ist nur eine Datumseingabe erlaubt
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
      <b-form-group class="form-group details-group">
        <b-row>
          <b-col md="" sm="12" class="label-col">
            <label class="mandatory d-inline-block">
              <slot name="firstNameLabel">Details zur Kündigung</slot>
            </label>
          </b-col>
          <b-col md="" sm="12" class="form-col first-name-col indicator">
            <b-form-input
              name="details"
              type="text"
              :placeholder="getSlotText('detailsPlaceholder', 'Hier können Sie uns weitere Informationen zu Ihrer Kündigung mitteilen.')"
              v-model="cancellation.details"
              @change="$v.cancellation.details.$touch"
              :state="isValid('details', 'cancellation')"
              aria-describedby="details-live-feedback"
            >
            </b-form-input>
            <slot name="detailsIndication"></slot>
            <b-form-invalid-feedback id="details-live-feedback">
              <slot v-if="!isValid('details','cancellation')" name="detailsLiveFeedback">
                Bitte prüfen Sie Ihre Eingabe. In diesem Feld ist nur eine Eingabe von maximal 800 Zeichen erlaubt.
              </slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-form-group>
    </b-form>
    <captcha @captchaCode="updateCaptchaData">
    </captcha>
    <Stepper
      @next="save()"
      :loading-next="loading"
      :show-prev="false"
      :disabled-next="!oneFieldFilled || loading"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import isValid from '@/mixins/isValid'
import { validationMixin } from 'vuelidate'
import { email, helpers, maxLength } from 'vuelidate/lib/validators'
import { validZipCode, validCityString } from '@/validators/address'
import Stepper from '../../../generic/Stepper.vue'
import slotProxy from '@/mixins/slotProxy'
import { mapActions, mapMutations } from 'vuex'
import { stepName as nextStep } from './CancellationSuccess.vue'
import Captcha from '@/components/process/LIDL/Cancellation/Captcha.vue'

const alphaNumAndDSpecialChars = helpers.regex('alphaNumAndDSpecialChars', /^[a-zA-Z0-9äöüÄÖÜß/. ,-]*$/)
const numAndDSpecialChars = helpers.regex('numAndDSpecialChars', /^[0-9/.,-]*$/)
const date = helpers.regex('date', /^(([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})|(frühestmöglich))$/)

export const stepName = 'cancellationForm'

export default {
  name: 'CancellationForm',
  components: {
    Captcha,
    Stepper,
    BFormGroup,
    BForm,
    BFormInput
  },
  mixins: [
    isValid,
    validationMixin,
    slotProxy()
  ],
  data () {
    return {
      cancellation: {
        address: {
          street: null,
          houseNumber: null,
          zip: null,
          city: null
        },
        email: null,
        customer: {
          firstName: null,
          lastName: null,
          customerID: null,
          contractID: null
        },
        captcha: {
          captchaToken: null,
          captchaCode: null
        },
        preferredCancellationDate: 'frühestmöglich',
        details: null
      },
      loading: false
    }
  },
  methods: {
    ...mapActions('cancel', ['confirmCancellation']),
    ...mapMutations('cancel', ['changeStep']),
    save () {
      this.loading = true
      this.confirmCancellation({ cancellationData: this.cancellation, nextStep: nextStep })
      this.loading = false
    },
    updateCaptchaData (captchaData) {
      this.cancellation.captcha = captchaData
    }
  },
  computed: {
    oneFieldFilled () {
      if (this.cancellation.captcha.captchaCode !== null && this.cancellation.captcha.captchaCode !== '') {
        if (this.cancellation.customer.firstName !== null && this.cancellation.customer.firstName !== '') {
          return true
        }
        if (this.cancellation.customer.lastName !== null && this.cancellation.customer.lastName !== '') {
          return true
        }
        if (this.cancellation.customer.customerID !== null && this.cancellation.customer.customerID !== '') {
          return true
        }
        if (this.cancellation.customer.contractID !== null && this.cancellation.customer.contractID !== '') {
          return true
        }
        if (this.cancellation.email !== null && this.cancellation.email !== '') {
          return true
        }
        if (this.cancellation.preferredCancellationDate !== null && this.cancellation.preferredCancellationDate !== '' && this.cancellation.preferredCancellationDate !== 'frühestmöglich') {
          return true
        }
        if (this.cancellation.details !== null && this.cancellation.details !== '') {
          return true
        }
        if (this.cancellation.address.street !== null && this.cancellation.address.street !== '') {
          return true
        }
        if (this.cancellation.address.zip !== null && this.cancellation.address.zip !== '') {
          return true
        }
        if (this.cancellation.address.city !== null && this.cancellation.address.city !== '') {
          return true
        }
        return this.cancellation.address.houseNumber !== null && this.cancellation.address.houseNumber !== ''
      } else {
        return false
      }
    }
  },
  validations () {
    return {
      cancellation: {
        address: {
          street: {
            alphaNumAndDSpecialChars
          },
          houseNumber: {
            alphaNumAndDSpecialChars
          },
          zip: {
            validZipCode
          },
          city: {
            validCityString
          }
        },
        email: {
          email
        },
        customer: {
          firstName: {
            alphaNumAndDSpecialChars
          },
          lastName: {
            alphaNumAndDSpecialChars
          },
          customerID: {
            numAndDSpecialChars,
            maxLength: maxLength(70)
          },
          contractID: {
            numAndDSpecialChars,
            maxLength: maxLength(70)
          }
        },
        preferredCancellationDate: {
          date
        },
        details: {
          maxLength: maxLength(800)
        }
      }
    }
  }
}
</script>
